/*
 * Build flag for the TEEN SELF-HOLDER flow (design MY-DESIGN-JUNIOR-SELF-
 * HOLDER-1020 §4.3 / §6 PR3; PROGRAMME-RULE-TEEN-SELF-HOLDER-TRANSACTIONAL-
 * EMAIL-V1). Same shape as profileLinksEnabled / brandSignupEnabled:
 *
 *   VITE_TEEN_SELF_HOLDER_ENABLED === 'true' → the "Myself" age step on a band
 *     spanning 18 (or no band), the Get ready "Parent/guardian signature
 *     needed" card states, the WaiverFlow 422 hand-off and the public
 *     /guardian-sign/:token page exist. Absent or anything else = OFF: every
 *     one of those surfaces is exactly as before (no route, no request).
 *
 * The env is injectable so tests can pin both sides.
 */
export function teenSelfHolderEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_TEEN_SELF_HOLDER_ENABLED === 'true'
}
